import ExpenseBudgetModel from 'models/ExpenseBudgetModel';

export default class ExpenseBudgetItemModel extends ExpenseBudgetModel {
	static get path(): string {
		return '/expenses/{?id}/_budget';
	}
}
